import { getParentLinking } from "../core/layer/utils/useMarkParentLinking";
import { getRootProps, isRoot } from "../core/layer/chain/store/useStoreRoot";
import useDiscard from "../core/useDiscard";
import useMap from "../core/utils/useMap";
import useWeakMap from "../core/utils/useWeakMap";

const store = useWeakMap();
const onDiscardProps = props => store.delete(props);

const getTargetProps = props => getParentLinking(props) || getRootProps(props) || props;


const createRefListIfNotExist = (props, refName) => {
    if(!store.has(props)){
        store.set(props, useMap());
    }
    if (!store.get(props).has(refName)) {
        store.get(props).set(refName, {
            elements: []
        });
    }
    return store.get(props).get(refName);
}

const initElementRefList = (props) => {
    props = getTargetProps(props)
    store.set(props, useMap());
    useDiscard(props, onDiscardProps);
    const useElementRef = (refName) => {
        return createRefListIfNotExist(props, refName);
    }
    return useElementRef;
}

export const setElementRefList = (props, refName, nodes) => {
    props = getTargetProps(props)
    if (props == null) return;
    const ref = createRefListIfNotExist(props, refName);
    ref.elements = nodes
}

export default initElementRefList;